const ZeekScript = () => {
    return {
        token: function (stream, state) {
            var ch = stream.peek();

            if (stream.match(/"(?:[^\\]|\\.)*?(?:"|$)/)) { return 'string' }
            if (stream.match(/(T|F)\b/)) { return 'atom' }
            if (stream.match(/#.*/)) { return 'comment' }
            if (stream.match(/(@load)/)) { return 'keyword' }
            if (stream.match(/(?:add|alarm|break|case|const|continue|delete|do|else|enum|event|export|for|function|if|global|local|module|next|of|print|redef|return|schedule|type|when|while)\b/)) { return 'keyword' }
            if (stream.match(/(&|\+\=|=)/)) { return 'operator' }
            if (stream.match(/0x[a-f\d]+|[-+]?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?/i)) { return 'number' }

            /* nothing found, continue */
            state.pairStart = false;
            state.escaped = (ch === '\\');
            stream.next();
            return null;
        },
        startState: function () {
            return {
                pair: false,
                pairStart: false,
                keyCol: 0,
                inlinePairs: 0,
                inlineList: 0,
                literal: false,
                escaped: false
            };
        },
        lineComment: '#',
        fold: 'indent',
        dontIndentStates: ['comment'],
    };
};

export {
    ZeekScript as default
};
